import { Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import classNames from 'classnames/bind';
import { i18nKeys, useTranslation } from 'locales';
import { IconName } from 'shared/components/Icon';
import OnboardingItem from 'shared/components/OnboardingItem';
import PaymentForm from 'shared/forms/PaymentForm';
import { onBoardingActions } from 'store/onBoarding/onBoarding.actions';
import { DialogShowId, DialogShowSize, dialogHide, showDialog } from 'store/view/view.actions';

import type { StepProps } from '../OnBoarding.types';
import styleIdentifiers from './paymentMethod.module.scss';
import Twikey from './Twikey';

const styles = classNames.bind(styleIdentifiers);

export default function PaymentMethod({ onValidStep }: StepProps) {
  const { t } = useTranslation();

  const callback = () => {
    dialogHide(DialogShowId.CUSTOM);
    onValidStep();
  };

  const addStripe = (data: any) => {
    onBoardingActions.stripe({
      callback,
      data,
    });
  };

  const chooseStripe = () => {
    showDialog({
      id: DialogShowId.CUSTOM,
      size: DialogShowSize.MEDIUM,
      title: t(i18nKeys.CREDIT_CARD),
      children: <PaymentForm onSubmit={addStripe} />,
    });
  };

  const chooseTwikey = () => {
    showDialog({
      id: DialogShowId.CUSTOM,
      size: DialogShowSize.SMALL,
      title: t(i18nKeys.ONBOARDING[1].DIRECT_DEBIT.TITLE),
      children: <Twikey onboarding onSubmit={() => onValidStep()} />,
    });
  };

  const chooseLater = () => {
    modals.openConfirmModal({
      title: t(i18nKeys.CONFIRM),
      centered: true,
      children: <Text size="sm">{t(i18nKeys.ONBOARDING[1].AYS_TO_NOT_ADD_PAYMENT_METHOD)}</Text>,
      labels: { confirm: t(i18nKeys.CONFIRM), cancel: t(i18nKeys.CANCEL) },
      onConfirm: () => {
        onBoardingActions.noPayment({
          callback: () => {
            onValidStep();
          },
        });
      },
    });
  };

  return (
    <div className={styles('payment-method')}>
      <div className={styles('steps')}>
        <OnboardingItem
          title={t(i18nKeys.ONBOARDING[1].DIRECT_DEBIT.TITLE)}
          icon={IconName.DOMICILIATION}
          onClick={chooseTwikey}
          paddingBottom
          description={t(i18nKeys.ONBOARDING[1].DIRECT_DEBIT.DESCRIPTION)}
        />
        <OnboardingItem
          title={t(i18nKeys.CREDIT_CARD)}
          icon={IconName.CREDIT_CARD}
          onClick={chooseStripe}
          paddingBottom
          description={t(i18nKeys.ONBOARDING[1].CREDIT_CARD.DESCRIPTION)}
        />
        <OnboardingItem
          title={t(i18nKeys.ADD_LATER)}
          icon={IconName.LATER}
          onClick={chooseLater}
          paddingBottom
        />
      </div>
    </div>
  );
}
